import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

declare global {
    interface Window {
        WESTETICS_CONFIG: {
            apiUrl: string;
            environment: string;
            production: boolean;
            mapboxToken: string;
        };
    }
}

@Injectable({
    providedIn: 'root'
})
export class GlobalConfigService {

    constructor() {
        this.initializeGlobalConfig();
    }

    private initializeGlobalConfig(): void {
        // Obtém a variável de ambiente profile (dev, prod, local)
        const profile = this.getProfileFromEnvironment();

        // Define a configuração baseada no profile
        const config = this.getConfigByProfile(profile);

        // Define a variável global
        window.WESTETICS_CONFIG = config;

    }

    private getProfileFromEnvironment(): string {
        // 1. Verifica se foi definido via window (para casos especiais)
        if ((window as any).__WESTETICS_PROFILE__) {
            return (window as any).__WESTETICS_PROFILE__;
        }
        
        // 2. PRIORIZA a configuração do Angular environment
        // O Angular CLI já substitui o arquivo correto baseado na configuração
        let profile: string;
        
        // Detecta baseado no environment.apiUrl (mais confiável que hostname)
        if (environment.apiUrl.includes('localhost')) {
            profile = 'local';
        } else if (environment.apiUrl.includes('dev.westetics.com.br')) {
            profile = 'dev';
        } else if (environment.apiUrl.includes('server.westetics.com.br')) {
            profile = 'prod';
        } else {
            // Fallback baseado no environment.production
            profile = 'prod';
        }
        
        return profile;
    }

    private getConfigByProfile(profile: string) {
        const configs = {
            'local': {
                apiUrl: 'http://localhost:8081',
                environment: 'local',
                production: false,
                mapboxToken: environment.mapboxToken
            },
            'dev': {
                apiUrl: 'https://dev.westetics.com.br',
                environment: 'dev',
                production: false,
                mapboxToken: environment.mapboxToken
            },
            'prod': {
                apiUrl: 'https://server.westetics.com.br',
                environment: 'prod',
                production: true,
                mapboxToken: environment.mapboxToken
            }
        };

        return configs[profile as keyof typeof configs] || configs['local'];
    }

    // Método público para acessar a configuração global
    public getGlobalConfig() {
        return window.WESTETICS_CONFIG;
    }

    // Métodos de conveniência
    public getApiUrl(): string {
        return window.WESTETICS_CONFIG.apiUrl;
    }

    public isProduction(): boolean {
        return window.WESTETICS_CONFIG.production;
    }

    public getEnvironment(): string {
        return window.WESTETICS_CONFIG.environment;
    }

    public getMapboxToken(): string {
        return window.WESTETICS_CONFIG.mapboxToken;
    }
}
